import {useState} from "react";
import {BsEraserFill} from "react-icons/bs";
import baseUrl from "../../../baseUrl";
import {requester} from "../../../services/requester";
import {adjustedUnsuitable, adjustedSuitable} from "../../../utils/pravno";
import styles from "./InitInfo.module.css";

export const InitInfo = ({initInfo, correction, onInitInfoSubmit}) => {
    const request = requester();
    const [showEdit, setShowEdit] = useState(false);
    const [values, setValues] = useState({declared_land: "", unsuitable_land: "", suitable_land: ""});

    const изходниСтойности = () => ({
        declared_land: initInfo.declared_land,
        unsuitable_land: initInfo.unsuitable_land,
        suitable_land: initInfo.suitable_land
    });

    const toggleShowEdit = () => {
        // Редакцията пипа СУРОВИТЕ стойности от базата,
        // не коригираните с correction, които таблицата показва.
        setValues(изходниСтойности());
        setShowEdit(!showEdit);
    };

    // Ш1: изход без запис — връща полетата към записаното и прибира реда.
    const затвори = () => {
        setValues(изходниСтойности());
        setShowEdit(false);
    };

    const changeHandler = (e) => {
        setValues(state => ({...state, [e.target.name]: e.target.value}));
    };

    const onSaveHandle = async () => {
        try {
            await request.put(`${baseUrl()}/companies-initial-info/${initInfo.id}`, {
                company_name: initInfo.company_name,
                declared_land: Number(values.declared_land),
                unsuitable_land: Number(values.unsuitable_land),
                suitable_land: Number(values.suitable_land)
            });
            onInitInfoSubmit();
            setShowEdit(false);
        } catch (err) {
            alert(err.message || 'Възникна грешка при заявката.');
        }
    };

    return (
        <div className={`d-flex justify-content-center ${styles.wrap}`}>
            {/* Ч1: надписът се отдръпва (дребен и сив), числото застава на
                повдигната плочка — трите изходни площи трябва да се хващат с
                едно поглеждане, а не да се четат наравно с останалия текст. */}
            <table className="table">
                <thead>
                <tr>
                    <th scope="col" className={styles.label}>Декларирана</th>
                    <th scope="col" className={styles.label}>Необработваема</th>
                    <th scope="col" className={styles.label}>Годна</th>
                    <th scope="col" style={{width: "1%"}}></th>
                </tr>
                </thead>
                <tbody>
                <tr>
                    <td className="text-center">
                        <span className={styles.value}>{initInfo.declared_land?.toFixed(2)}</span>
                    </td>
                    <td className="text-center">
                        <span className={styles.value}>
                            {adjustedUnsuitable(initInfo.unsuitable_land, correction).toFixed(2)}
                        </span>
                    </td>
                    <td className="text-center">
                        <span className={styles.value}>
                            {adjustedSuitable(initInfo.suitable_land, correction).toFixed(2)}
                        </span>
                    </td>
                    <td className="align-middle">
                        {initInfo.id && (
                            <button onClick={toggleShowEdit} data-bs-toggle="tooltip"
                                    title="Редакция на изходните площи" type="button"
                                    className="btn btn-sm btn-warning"><BsEraserFill/></button>
                        )}
                    </td>
                </tr>
                {showEdit && (
                    <tr style={{background: "var(--app-neutral-bg)"}}>
                        <td className="text-center">
                            <input onChange={changeHandler} size={7} type="text"
                                   value={values.declared_land} name="declared_land"/>
                        </td>
                        <td className="text-center">
                            <input onChange={changeHandler} size={7} type="text"
                                   value={values.unsuitable_land} name="unsuitable_land"/>
                        </td>
                        <td className="text-center">
                            <input onChange={changeHandler} size={7} type="text"
                                   value={values.suitable_land} name="suitable_land"/>
                        </td>
                        <td>
                            <div className="d-flex gap-1">
                                <button onClick={onSaveHandle} type="button"
                                        className="btn btn-sm btn-warning">Запази
                                </button>
                                {/* Ш1 */}
                                <button onClick={затвори} type="button"
                                        className="btn btn-sm btn-outline-secondary">Затвори
                                </button>
                            </div>
                        </td>
                    </tr>
                )}
                {showEdit && (correction || 0) !== 0 && (
                    <tr>
                        <td colSpan={4} className="text-center"
                            style={{fontSize: "13px", color: "var(--app-muted)", fontStyle: "italic"}}>
                            Редактират се суровите стойности от базата — без отчетената корекция
                            ({Number(correction).toFixed(2)}).
                        </td>
                    </tr>
                )}
                </tbody>
            </table>
        </div>
    );
};
